import React from 'react';
import { node, string, oneOf } from 'prop-types';
import StatusAlert from 'wix-ui-icons-common/StatusAlert';
import Info from 'wix-ui-icons-common/InfoCircle';
import Check from 'wix-ui-icons-common/Check';
import styles from './Banner.scss';
import classNames from 'classnames';
import { Text } from 'wix-style-react';

export const BANNER_TYPES = {
  STANDARD: 'standard',
  SUCCESS: 'success',
  ERROR: 'error',
  INFO: 'info',
};

export default function Banner(props) {
  const prefix = getPrefix(props.type);
  const className = getClassName(props.type);

  const wrapperClassName = classNames(className, props.className, {
    [styles.hasPrefix]: Boolean(prefix),
  });

  return (
    <div className={wrapperClassName} data-hook="banner-notification-wrapper">
      {prefix}
      <Text size="small" weight="normal" data-hook="banner-notification-text">
        {props.children}
      </Text>
    </div>
  );
}

Banner.propTypes = {
  children: node,
  className: string,
  type: oneOf(Object.values(BANNER_TYPES)),
};
Banner.defaultProps = {
  type: BANNER_TYPES.STANDARD,
};

function getPrefix(type) {
  let prefix = null;

  switch (type) {
    case BANNER_TYPES.ERROR:
      prefix = <StatusAlert />;
      break;
    case BANNER_TYPES.INFO:
      prefix = <Info />;
      break;
    case BANNER_TYPES.SUCCESS:
      prefix = <Check />;
      break;
  }

  return prefix;
}

function getClassName(type) {
  const className = [styles.wrapper];

  switch (type) {
    case BANNER_TYPES.INFO:
    case BANNER_TYPES.STANDARD:
      className.push(styles.standard);
      break;
    case BANNER_TYPES.SUCCESS:
      className.push(styles.success);
      break;
    case BANNER_TYPES.ERROR:
      className.push(styles.error);
      break;
  }

  return className.join(' ');
}
